<style src="./style.scss">
</style>

<script lang="ts">
  import { onMount } from "svelte";

  import { navigate, useLocation } from "svelte-navigator";
  import Icon from "svelte-icon";

  import Button from "@components/button";
  import Header from "@components/header";
  import Footer from "@components/footer";

  import UnsubscribeSuccessImage from "@assets/images/unsubscribe-success.svg";
  import GuaranteedUnsubscribeSuccessImage from "@assets/images/guaranteed-unsubscribe-success.svg";

  import InfoIcon from "@assets/icons/info.svg";

  const location = useLocation();

  let endAt = null;

  onMount(() => {
    const date = new Date($location.state.endAt);

    endAt = `${date.toLocaleString("pt-br", {
      day: "2-digit",
    })} de ${date.toLocaleString("pt-br", {
      month: "long",
    })} de ${date.getFullYear()}`;
  });

  function goOverview() {
    navigate("/overview");
  }
</script>

<Header />

<div class="unsubscribe-success">
  <div class="unsubscribe-success__content">
    {#if $location.state?.isGuaranteed}
      <Icon
        data="{GuaranteedUnsubscribeSuccessImage}"
        size="170px"
        stroke="transparent" />
    {:else}
      <Icon
        data="{UnsubscribeSuccessImage}"
        size="170px"
        stroke="transparent" />
    {/if}

    <h1>Cancelamento realizado</h1>

    {#if $location.state?.isGuaranteed}
      <div class="unsubscribe-success__content__info">
        <div class="unsubscribe-success__content__info__icon">
          <Icon data="{InfoIcon}" size="16px" stroke="transparent" />
        </div>

        Sua assinatura está cancelada e seu acesso ao CNA Go interrompido. Como
        sua solicitação foi feita dentro do período de Satisfação Garantida,
        você terá o reembolso integral do valor já pago.
      </div>
    {/if}
    <p>
      {#if $location.state?.isGuaranteed}
        O prazo para você receber o reembolso depende da sua operadora de cartão
        de crédito, podendo variar de 30 minutos a até 2 faturas. Em caso de
        dúvidas, consulte seu banco.
      {:else if $location.state.amount === 0}
        Sua assinatura está cancelada, a partir deste momento você não tem mais
        acesso aos serviços do CNA Go.
      {:else}
        Sua assinatura está cancelada. Você ainda pode usar a plataforma e os
        serviços contratados até {endAt}. Após este período, sua assinatura não
        será mais renovada.
      {/if}
    </p>

    <Button title="Finalizar" onClick="{goOverview}" />
  </div>
</div>

<div class="desktop-only">
  <Footer />
</div>
